import { type FC, type PropsWithChildren } from "react";

import { cn } from "../utils";

export const AppTopBar: FC<PropsWithChildren> = (props) => {
	return (
		<div
			data-tauri-drag-region
			className={cn(
				"sticky",
				"top-0",
				"left-0",
				"right-0",
				"box-content",
				"flex",
				"h-10",
				"shrink-0",
				"grow-0",
				"pb-px",
				"shadow-border-inset-bottom",
				"z-surface",
				"bg-primary"
			)}
		>
			{props.children}
		</div>
	);
};
